import { defineComponent, PropType } from 'vue';

import { Widget } from '~/models/widget.model';
import ComponentBase from '~/components/component-base';
import WidgetBase, { WidgetMode } from '~/components/widgets/widget.vue';

export default defineComponent({

  extends: ComponentBase,

  components: {
    WidgetBase,
  },

  props: {
    widget: { type: Object as PropType<Widget> },
    widgetMode: { type: String as PropType<WidgetMode>, default: WidgetMode.SHOW },
  },

  computed: {
    editable() {
      return this.widgetMode === WidgetMode.EDIT;
    },

    addable() {
      return this.widgetMode === WidgetMode.ADD;
    },

    showable() {
      return this.widgetMode === WidgetMode.SHOW;
    },

    fake(): boolean {
      return this.addable || this.editable;
    }
  }
})